<template>
  <!--
      	作者：gmshop
      	时间：2019-06-04
      	描述：插件中心-优惠券-优惠券列表-添加优惠券
      -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <!--添加门店-->
      <div class="common-form">添加优惠券</div>
      <el-form-item label="优惠券名称" prop="name" :rules="[{ required: true, message: ' ' }]">
        <el-input v-model="form.name" placeholder="请输入优惠券名称"></el-input>
        <div class="tips">例如：满100减10</div>
      </el-form-item>
      <!-- <el-form-item label="优惠券颜色">
        <el-radio-group v-model="form.color">
          <el-radio label="10">蓝色</el-radio>
          <el-radio label="20">红色</el-radio>
          <el-radio label="30">紫色</el-radio>
          <el-radio label="40">黄色</el-radio>
        </el-radio-group>
      </el-form-item> -->
      <el-form-item label="优惠券类型">
        <el-radio-group v-model="form.coupon_type">
          <el-radio label="10">满减券</el-radio>
          <el-radio label="20">折扣券</el-radio>
          <el-radio v-auth="'/service'" label="30">体验券</el-radio>
        </el-radio-group>
      </el-form-item>
      <template v-if="form.coupon_type != 30">
        <div v-if="form.coupon_type == 10">
          <el-form-item label="减免金额" prop="reduce_price" :rules="[{ required: true, message: ' ' }]"><el-input v-model="form.reduce_price" placeholder="请输入减免金额" type="number"></el-input></el-form-item>
        </div>
        <div v-else>
          <el-form-item label="折扣率 " prop="discount" :rules="[{ required: true, message: ' ' }]">
            <el-input v-model="form.discount" placeholder="请输入折扣率" type="number"></el-input>
            <div class="tips">折扣率范围0-10，9.5代表9.5折，0代表不折扣</div>
          </el-form-item>
        </div>

        <el-form-item label="最低消费金额" prop="min_price" :rules="[{ required: true, message: ' ' }]"><el-input v-model="form.min_price" placeholder="请输入最低消费金额" type="number"></el-input></el-form-item>

        <el-form-item label="适用产品" prop="product_type" :rules="[{ required: true, message: ' ' }]">
          <el-radio-group v-model="form.product_type">
            <el-radio label="10">所有产品</el-radio>
            <el-radio label="20">指定产品</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-if="form.product_type == '20'" label="选择商品">
          <el-row>
            <el-button type="primary" icon="el-icon-plus" @click="openProductDialog">选择商品</el-button>
            <div class="draggable-list">
              <div v-for="(item,index) in products" :key="index" class="item">
                <div style="height:100%">
                  <div>
                    <img class="img" :src="item.product_image" />
                    <div class="name">{{item.product_name}}</div>
                  </div>
                </div>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i class="el-icon-close"></i></a>
              </div>
            </div>
          </el-row>
        </el-form-item>
        <el-form-item v-if="form.product_type == '20'" v-auth="'/service'" label="选择服务">
          <el-row>
            <el-button type="primary" icon="el-icon-plus" @click="openServiceDialog1">选择服务</el-button>
            <div class="draggable-list">
              <div v-for="(item,index) in services" :key="index" class="item">
                <div style="height:100%">
                  <div>
                    <img class="img" :src="item.image.file_path" />
                    <div class="name">{{item.name}}</div>
                  </div>
                </div>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg1(index)"><i class="el-icon-close"></i></a>
              </div>
            </div>
          </el-row>
        </el-form-item>
      </template>
      <template v-if="form.coupon_type == '30'" v-auth="'/service'">
        <el-form-item label="选择服务" :rules="[{ required: true, message: '请选择服务' }]" prop="service_id">
          <el-row>
            <el-button type="primary" icon="el-icon-plus" @click="openServiceDialog">选择1款服务</el-button>
            <div v-if="form.service_id" class="img">
                <img :src="service.image ? service.image.file_path : ''" width="100" height="100" />
                <span>{{service.name}}</span>
              </div>
          </el-row>
        </el-form-item>
      </template>

      <el-form-item label="到期类型">
        <el-radio-group v-model="form.expire_type">
          <el-radio label="10">领取后生效</el-radio>
          <el-radio label="20">固定时间</el-radio>
        </el-radio-group>
      </el-form-item>
      <div v-if="form.expire_type == 10">
        <el-form-item label="有效天数"><el-input v-model="form.expire_day" placeholder="请输入有效天数" type="number"></el-input></el-form-item>
      </div>
      <div v-else>
        <el-form-item label="有效时间">
          <el-date-picker
            v-model="form.active_time"
            type="daterange"
            align="right"
            unlink-panels
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions0"
          ></el-date-picker>
        </el-form-item>
      </div>

      <el-form-item label="发放总数量 " prop="total_num" :rules="[{ required: true, message: ' ' }]">
        <el-input v-model="form.total_num" placeholder="请输入发放总数量" type="number"></el-input>
        <div class="tips">限制领取的优惠券数量，-1为不限制</div>
      </el-form-item>

      <el-form-item label="单次领数量 " prop="each_qty" :rules="[{ required: true, message: ' ' }]">
        <el-input v-model="form.each_qty" placeholder="请输入单次领数量" type="number"></el-input>
        <div class="tips">单次领数量，默认1张，若N张，那单次领取N张</div>
      </el-form-item>

      <el-form-item label="是否显示在领券中心">
        <el-radio-group v-model="form.show_center">
          <el-radio :label="1">显示</el-radio>
          <el-radio :label="0">不显示</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="使用条件">
        <el-radio-group v-model="form.free_limit">
          <el-radio :label="0">不限制</el-radio>
          <el-radio :label="1">不可与促销同时使用</el-radio>
          <el-radio :label="2">不可与等级优惠同时使用</el-radio>
          <el-radio :label="3">不可于促销和等级优惠同时使用</el-radio>
        </el-radio-group>
        <div class="tips">促销是指满减，等级优惠券值商品的会员等级折扣</div>
      </el-form-item>
      <el-form-item label="排序"><el-input type="number" v-model="form.sort" placeholder="请输入排序"></el-input></el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="info" size="small" @click="cancelFunc" :loading="loading">取消</el-button>
        <el-button type="primary" size="small" @click="onSubmit" :loading="loading">提交</el-button>
       </div>
    </el-form>
    <!--商品选择-->
    <Product :isproduct="open_product" :excludeIds="excludeIds" :islist="true" @closeDialog="closeProductDialog"></Product>
    <!-- 选择服务 -->
    <GetService :is_open="open_services" :excludeIds="excludeIds3" :islist="true" @close="closeServiceDialog1"></GetService>
    <GetService :is_open="open_service" :excludeIds="excludeIds1" :islist="false" @close="closeServiceDialog"></GetService>

  </div>
</template>

<script>
import CouponApi from '@/api/coupon.js';
import Product from '@/components/product/Product.vue';
import GetService from '@/components/service/GetService.vue';
export default {
  components: {
    Product,
    GetService
  },
  data() {
    return {
      /*切换菜单*/
      // activeIndex: '1',
      /*form表单数据*/
      form: {
        color: '20',
        coupon_type: '10',
        expire_type: '10',
        sort: 1,
        active_time: '',
        show_center: 1,
        /*优惠限制0不显示1不可与促销同时2不可与等级优惠同时3不可于促销和等级同*/
        free_limit: 0,
        product_type: '10',
        product_ids: [],
        service_ids: [],
        service_id: '',
      },
      excludeIds:[],  //适用服数据
      excludeIds1:[],  //体验券服务数据
      excludeIds3:[],  //适用服务数据
      open_product: false,
      open_services: false,
      open_service: false,
      products:[],
      services:[],
      service:[],
      loading: false,
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; //如果没有后面的-8.64e7就是不可以选择今天的
        }
      }
    };
  },
  created() {},

  methods: {
    /*添加用户*/
    onSubmit() {
      let self = this;
      let form = self.form;
      form.product_ids = this.excludeIds;
      form.service_ids = this.excludeIds3;
      if (form.coupon_type != 30 && form.product_type == 20 && form.product_ids.length < 1 && form.service_ids.length < 1) {
        self.$message({
          message: '必须添加一个适用商品或者服务',
          type: 'error'
        });
        return false;
      }
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          CouponApi.addCoupon(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '恭喜你，添加成功',
                type: 'success'
              });
              self.$router.push('/plus/coupon/index');
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消*/
    cancelFunc(){
      this.$router.push({
        path:'/plus/coupon/index',
      });
    },
    /*添加商品*/
    openProductDialog() {
      this.open_product = true;
    },

    /*关闭产品弹窗*/
    closeProductDialog(e) {
      if (e.type != 'error') {
        e.params.forEach(val => {
          if(this.excludeIds.indexOf(val.product_id) == -1) {
            this.excludeIds.push(val.product_id);
            this.products.push(val);
          }
        });
      }
      this.open_product = false;
    },
    /*添加服务*/
    openServiceDialog() {
      this.open_service = true;
    },

    /*添加服务服务*/
    openServiceDialog1() {
      this.open_services = true;
    },

    /*关闭服务弹窗*/
    closeServiceDialog(e) {
      if (e.type != 'error') {
        this.service = e.params;
        this.form.service_id = this.service.id;
        this.excludeIds1 = [this.service.id]
      }
      this.open_service = false;
    },

    /*关闭服务弹窗*/
    closeServiceDialog1(e) {
      if (e.type != 'error') {
        e.params.forEach(val => {
          if(this.excludeIds3.indexOf(val.id) == -1) {
            this.excludeIds3.push(val.id);
            this.services.push(val);
          }
        });
      }
      this.open_services = false;
    },

    /*删除商品*/
    deleteImg(index) {
      this.excludeIds.splice(index, 1);
      this.products.splice(index, 1);
    },

    /*删除服务*/
    deleteImg1(index) {
      this.excludeIds3.splice(index, 1);
      this.services.splice(index, 1);
    },
  }
};
</script>

<style lang="scss" scoped>
.product-add {
  padding-bottom: 50px;
}

.tips {
  color: #ccc;
}
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .item {
  position: relative;
  width: 110px;
  height: 130px;
  margin-top: 10px;
  margin-right: 10px;
  overflow: hidden;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}
.draggable-list .item .img {
  width: 110px;
  height: 110px;
}
.name {
  height:20px;
  line-height:20px;
  background-color: #aaa;
  position: relative;
  top: -20px;
  opacity: 0.9;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/coupon/coupon/add.vue